import request from '@/router/axios';

const urlPrefix = '/sys'

/**
 * 获取记录数据表头
 * @param data
 */
export function queryTableColumns(data) {
  return request({
    url: urlPrefix + '/custom/customRecordData/queryTableColumns',
    method: 'post',
    data
  });
}
/**
 * 获取记录数据列表
 * @param data
 */
export function queryCustomRecordData(data) {
  return request({
    url: urlPrefix + '/custom/customRecordData/queryCustomRecordData',
    method: 'post',
    data
  });
}

/**
 * 导出(处理成功)
 * @param data
 */
export function exportCustomInfoExcel(data) {
  return request({
    url: urlPrefix + '/custom/customRecordData/exportCustomInfoExcel',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  });
}

/**
 * 导出变更动态数据（处理失败/待处理）
 * @param data
 */
export function exportCustomExcel(data) {
  return request({
    url: urlPrefix + '/custom/customRecordData/exportCustomExcel',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  });
}

/**
 * 确认
 * @param data
 */
export function confirmHandleData(data) {
  return request({
    url: urlPrefix + '/custom/customRecordData/confirmHandleData',
    method: 'post',
    data
  });
}
